/**
 * @generated SignedSource<<5545e901264350266263ecd9b7c8ef37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type dataHealthPage_ConfigBackupMutation$variables = Record<PropertyKey, never>;
export type dataHealthPage_ConfigBackupMutation$data = {
  readonly configBackup: {
    readonly configBackup: {
      readonly filename: string;
      readonly id: string;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type dataHealthPage_ConfigBackupMutation = {
  response: dataHealthPage_ConfigBackupMutation$data;
  variables: dataHealthPage_ConfigBackupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "ConfigBackup",
  "kind": "LinkedField",
  "name": "configBackup",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filename",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "dataHealthPage_ConfigBackupMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ConfigBackupMutationPayload",
        "kind": "LinkedField",
        "name": "configBackup",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "dataHealthPage_ConfigBackupMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ConfigBackupMutationPayload",
        "kind": "LinkedField",
        "name": "configBackup",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d46003e0003067a4c79aa4d4abeaddcf",
    "id": null,
    "metadata": {},
    "name": "dataHealthPage_ConfigBackupMutation",
    "operationKind": "mutation",
    "text": "mutation dataHealthPage_ConfigBackupMutation {\n  configBackup {\n    configBackup {\n      id\n      filename\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "74b4c2a0de64358b29ca1e634728a46e";

export default node;
